import ReactGA from "react-ga4";
import { apiFetch } from "../Components/ApiCall";
import { getAccessToken } from "../auth";
import { TRACK_URL } from "./constant";
import { getParentUrl } from "./parentUrlStore";

export const trackPage = (page) => {
  ReactGA.send({ hitType: "pageview", page });
};

export const trackEvent = async (action, data) => {
  const affiliateId = new URLSearchParams(window.location.search).get("affiliateId");
  const accessTokenObj = getAccessToken();
  const sessionId = localStorage.getItem("sessionId") || "";
  const referUrl = getParentUrl();

  const payload = {
    eventName: action,
    params: {
      ...data,
      referUrl,
    },
  };

  return apiFetch(
    `/api/v1/track/ga/event`,
    "POST",
    payload,
    {
      Cookie: `affiliateId=${affiliateId};sessionId=${sessionId}`,
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessTokenObj?.token}`,
    },
    TRACK_URL,
    { skipAuth: true, credentials: "include" }
  );
};
